<template>
  <v-container fluid background pa-4>
    <v-layout
      row
      wrap
      pa-3
      style="background-color: #fff; margin: 5px; border-radius: 5px"
    >
      <!-- command box -->
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md2 sm6 xs12 px-1>
            <v-select
              :items="Branch_List"
              label="สาขา"
              item-text="name"
              item-value="code"
              v-model="branchSelect"
              hide-details
            />
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-select
              :items="Department_List"
              label="แผนก"
              item-text="name"
              item-value="code"
              v-model="departmentSelect"
              hide-details
            />
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-text-field
              :label="$t('code')"
              type="text"
              v-model="emp_code"
              hide-details
            />
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-select
              :items="selectitems"
              :item-text="$t('txt')"
              item-value="val"
              :label="$t('duration')"
              v-model="ChoiceSelected"
              @change="selectChoice()"
            >
              <template slot="item" slot-scope="{ item }">
                <div>{{ $t(item.txt) }}</div>
              </template>
            </v-select>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-text-field
              :label="$t('fromdate')"
              type="date"
              v-model="from_date"
              hide-details
            />
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-text-field
              :label="$t('todate')"
              type="date"
              v-model="to_date"
              hide-details
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="success" @click="process()">
              <v-icon class="pr-2" size="16">fa-spinner</v-icon>
              <span>{{ $t("processor") }}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="info" @click="printTable()">
              <v-icon class="pr-2" size="16">fa-print</v-icon>
              <span>{{ $t("print") }}</span>
            </v-btn>
          </v-flex>
          <v-flex md2 sm6 xs12 px-1>
            <v-btn block color="primary" @click="doCopyTable()">
              <v-icon class="pr-2" size="16">fa-copy</v-icon>
              <span>{{ $t("copy") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-layout row wrap class="hidden-sm-and-up">
            <v-flex
              md12
              sm12
              xs12
              v-for="(item, index) in table_datalist"
              :key="index"
              @click="&quot;&quot;;"
            >
              <v-card class="coco-box-shadow coco-list-hover">
                <v-layout
                  align-center
                  justify-center
                  row
                  fill-height
                  wrap
                  class="coco-list-layout"
                >
                  <v-flex lg12 md12 sm12 xs12>
                    <v-layout row wrap>
                      <v-flex lg10 md10 sm10 xs10 px-5 class="hidden-sm-and-up">
                        <span class="coco-list-label-text content"
                          >{{ item.code }} :</span
                        >
                        <span>{{ item.name }}</span
                        ><br />
                        <span class="coco-list-label-text">
                          {{ $t("Department") + " : " }}
                          <span>{{ item.department_name }}</span>
                        </span>
                        <span class="coco-list-label-text">
                          {{ $t("Position") + " : " }}
                          <span>{{ item.position }}</span>
                        </span>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2 class="hidden-sm-and-up">
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="cyan lighten-2"
                            icon
                            flat
                            @click="viewcalendar(item.code)"
                          >
                            <v-icon>fas fa-calendar-alt</v-icon>
                          </v-btn>
                          <span>{{ $t("view") }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2 class="hidden-xs-only">
                        <v-tooltip bottom>
                          <v-btn
                            slot="activator"
                            color="cyan lighten-2"
                            icon
                            flat
                            @click="viewcalendar(item.code)"
                          >
                            <v-icon>fas fa-calendar-alt</v-icon>
                          </v-btn>
                          <span>{{ $t("view") }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout class="hidden-xs-only content">
            <v-flex md12 sm12 xs12 class="scroll-able">
              <table
                id="table_detail"
                class="table table-bordered coco-sticky-table"
              >
                <thead>
                  <tr
                    style="
                      background-color: #357ca5;
                      color: white;
                      vertical-align: middle;
                    "
                    v-html="showheadhtml"
                  ></tr>
                  <tr
                    style="
                      background-color: #357ca5;
                      color: white;
                      vertical-align: middle;
                    "
                    v-html="showheadhtml2"
                  ></tr>
                </thead>
                <tbody v-html="showbodyhtml"></tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <!-- FormDialog -->
      <v-snackbar
        v-model="snackbar"
        :timeout="3500"
        :top="'top'"
        :color="snackbarcolor"
      >
        {{ snackmsg }}
        <v-btn dark flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog
        v-model="calendarDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>ตารางสแกนนิ้ว</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="calendarDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md4>
                  <v-expansion-panel expand>
                    <v-expansion-panel-content
                      style="background-color: #ffffff"
                      v-for="(date, i) in head_date"
                      :key="i"
                      expand-icon
                    >
                      <div slot="header">
                        <v-card class="coco-box-shadow">
                          <v-layout
                            align-center
                            justify-center
                            row
                            fill-height
                            wrap
                          >
                            <v-flex lg1 md1 sm2 xs3 text-xs-center>
                              <v-icon>fa-calendar-alt</v-icon>
                            </v-flex>

                            <v-flex lg9 md9 sm8 xs6>
                              <v-layout row wrap>
                                <v-flex
                                  lg12
                                  md12
                                  sm12
                                  xs12
                                  class="hidden-sm-and-up"
                                >
                                  <span>{{ selectedformatDate(date) }}</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </div>

                      <v-card-text>
                        <!-- เพิ่มใหม่ วันที่เริ่มงาน hidden-xs-only content-->
                        <div v-for="(time, j) in time" :key="j">
                          <v-layout
                            row
                            wrap
                            v-if="
                              date == time.date &&
                              time.processTimeResults != null &&
                              time.isProfileHoliday == false
                            "
                            style="margin: 3px"
                          >
                            <v-flex xs6>
                              <v-layout
                                row
                                wrap
                                v-for="(checkin, k) in time.processTimeResults"
                                :key="k"
                              >
                                <v-flex xs6>
                                  <v-layout row wrap>
                                    <v-flex
                                      xs12
                                      text-xs-center
                                      v-if="checkin.time_plan != null"
                                    >
                                      <span>{{
                                        timeformat(checkin.time_plan)
                                      }}</span>
                                    </v-flex>
                                    <v-flex xs12 text-xs-center v-else>
                                      <span></span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs6>
                                  <v-layout row wrap>
                                    <v-flex
                                      xs12
                                      text-xs-center
                                      v-if="checkin.time_checkin != null"
                                    >
                                      <span
                                        v-if="
                                          timeformat(checkin.time_plan) <
                                          timeformat(checkin.time_checkin)
                                        "
                                        style="color: red"
                                        >{{
                                          timeformat(checkin.time_checkin)
                                        }}*</span
                                      >
                                      <span v-else style="color: green">{{
                                        timeformat(checkin.time_checkin)
                                      }}</span>
                                    </v-flex>
                                    <v-flex xs12 text-xs-center v-else>
                                      <span></span>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6>
                              <v-layout row wrap>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="time.isCommission.toString() == 'true'"
                                >
                                  <span style="color: green">ได้เบี้ยขยัน</span>
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_absenttime != number &&
                                    time.total_absenttime != num
                                  "
                                >
                                  <span style="color: #b71c1c"
                                    >จำนวนที่ขาด(เวลา)
                                    {{ time.total_absenttime }} นาที</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_absentday != number &&
                                    time.total_absentday != num
                                  "
                                >
                                  <span style="color: #e53935"
                                    >จำนวนที่ขาด(วัน)
                                    {{ time.total_absentday }} วัน</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_absenttime_event != number &&
                                    time.total_absenttime_event != num
                                  "
                                >
                                  <span style="color: red"
                                    >ขาดในวันหยุดพิเศษ
                                    {{ time.total_absentday }} วัน</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_ottime != number &&
                                    time.total_ottime != num
                                  "
                                >
                                  <span style="color: green"
                                    >ทำงานล่วงเวลา
                                    {{ time.total_ottime }} ชั่วโมง</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_ottime_event != number &&
                                    time.total_ottime_event != num
                                  "
                                >
                                  <span style="color: #009688"
                                    >ทำงานล่วงเวลาวันพิเศษ
                                    {{ time.total_ottime_event }} ชั่วโมง</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_out_before_time != number &&
                                    time.total_out_before_time != num
                                  "
                                >
                                  <span style="color: #9c27b0"
                                    >ออกก่อนเวลา
                                    {{ time.total_out_before_time }} นาที</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_leavetime != number &&
                                    time.total_leavetime != num
                                  "
                                >
                                  <span style="color: #fb8c00"
                                    >ลาหักเงิน
                                    {{ time.total_leavetime }} ชั่วโมง</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_leaveday != number &&
                                    time.total_leaveday != num
                                  "
                                >
                                  <span style="color: #e65100"
                                    >วันที่ลาหักเงิน
                                    {{ time.total_leaveday }} ชั่วโมง</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_leavetime_event != number &&
                                    time.total_leavetime_event != num
                                  "
                                >
                                  <span style="color: #ff6d00"
                                    >วันพิเศษที่ลา
                                    {{ time.total_leavetime_event }} วัน</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_leavetime_uncut != number &&
                                    time.total_leavetime_uncut != num
                                  "
                                >
                                  <span style="color: #f4511e"
                                    >ลาไม่หักเงิน
                                    {{
                                      time.total_leavetime_event
                                    }}
                                    ชั่วโมง</span
                                  >
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-center
                                  v-if="
                                    time.total_latetime != number &&
                                    time.total_latetime != num
                                  "
                                >
                                  <span style="color: #dd2c00"
                                    >สาย{{ time.total_latetime }} นาที</span
                                  >
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            row
                            wrap
                            v-if="time.processTimeResults == null"
                            style="margin: 3px"
                          >
                            <v-flex
                              xs12
                              v-if="
                                date == time.date &&
                                time.isProfileHoliday == true
                              "
                            >
                              <v-layout
                                row
                                wrap
                                style="
                                  text-align: center;
                                  background-color: #c5e1a5;
                                "
                              >
                                <v-flex xs12 text-xs-center>
                                  <span>{{ time.from }}</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex
                              xs12
                              v-else-if="
                                date == time.date &&
                                time.isHoliday == true &&
                                time.isProfileHoliday == false
                              "
                            >
                              <v-layout
                                row
                                wrap
                                style="
                                  text-align: center;
                                  background-color: #ef5350;
                                "
                              >
                                <v-flex xs12 text-xs-center>
                                  <span>วันหยุด</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import ProcessService from "@/services/ProcessService";
import PayrollService from "@/services/PayrollService";
import Empimage from "../../components/getempimage.vue";
import Utils from "@/utils/";
import XLSX from "xlsx";
import moment from "moment";
import { constants } from "crypto";

export default {
  data: () => ({
    payroll_doc: {
      doc_no: "",
      begin_date: "",
      end_date: "",
      remark: "",
      creator_code: localStorage._usercode,
    },
    snackbarcolor: "red",
    number: "0.0",
    num: "0",
    calendarDialog: false,
    emp_code: "",
    filterDialog: false,
    table_datalist: [],
    table_head_model: {
      ชื่อ: "1",
      date: [],
    },
    head_date: [],
    json_fields: {
      ชื่อ: "name",
      date: [],
    },
    selectitems: [
      { txt: "None", val: "" },
      { txt: "ThisMount", val: 0 },
      { txt: "ThisWeek", val: 1 },
      { txt: "Today", val: 2 },
      { txt: "LastWeek", val: 3 },
      { txt: "LastMount", val: 4 },
    ],
    ChoiceSelected: "",
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    buttonlist: 1,
    table_head_count: 1,
    pageActive: 1,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: "",
    },
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    responvalue: "",
    showbodyhtml: "",
    showheadhtml: "",
    showheadhtml2: "",
    bodyHtml: "",
    user_datafinger: [],
    time: [],
    datacheckin: [],
    branch_Select: "",
    department_Select: "",
    from_date: "",
    to_date: "",
  }),
  created: function () {
    this.setShowFilter({
      status: 0,
    });
    this.commitSetToolbar({
      patternTool: "1",
    });
    this.$store.watch(
      (state) => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
        state.filter.FromDate;
        state.filter.ToDate;
      },
      () => {},
      {
        deep: true,
      }
    );
  },
  destroyed: function () {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    Empimage,
  },
  computed: {
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate",
      "SearchData",
    ]),
    ...mapState("app", ["showLoading"]),
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      },
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      },
    },
    // from_date: {
    //   get() {
    //     return this.FromDate;
    //   },
    //   async set(value) {
    //     await this.selectedFormDate({ data: value });
    //   }
    // },
    // to_date: {
    //   get() {
    //     return this.ToDate;
    //   },
    //   async set(value) {
    //     await this.selectedToDate({ data: value });
    //   }
    // }
  },
  mounted: function () {
    console.log('ssss')
    this.getBranch();
  },
  methods: {
    ...mapMutations("filter", [
      "setShowFilter",
      "selectedFormDate",
      "selectedToDate",
      "getAllEmployeeByBranch",
      "selectedPosition",
    ]),
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    _today() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output =
        d.getFullYear() +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (day < 10 ? "0" : "") +
        day;

      return output;
    },
    showCreateDocDialog() {
      if (
        this.FromDate == "" ||
        this.FromDate == undefined ||
        this.ToDate == "" ||
        this.FromDate == undefined ||
        this.SelectBranch == ""
      ) {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขาจากวันที่ถึงวันที่";
      } else {
        this.payroll_doc.doc_no = this._docno("PR") + this._docdate();
        this.payroll_doc.begin_date = this.FromDate;
        this.payroll_doc.end_date = this.ToDate;
        this.docDialog = true;
      }
    },
    _docno(head) {
      return (
        head +
        "-xxx".replace(/[xy]/g, function (c) {
          var r = (Math.random() * 8) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        })
      );
    },
    _docdate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var min = d.getMinutes();

      var output =
        d.getFullYear() +
        "" +
        (month < 10 ? "0" : "") +
        month +
        "" +
        (day < 10 ? "0" : "") +
        day +
        hour +
        min;

      return output;
    },
    selectChoice() {
      if (this.ChoiceSelected == 0) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.from_date = this.selectedformatDates(firstDay);
        this.to_date = this.selectedformatDates(lastDay);
        // this.process();
      } else if (this.ChoiceSelected == 1) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first + 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        this.from_date = this.selectedformatDates(firstday);
        this.to_date = this.selectedformatDates(lastday);
        // this.process();
      } else if (this.ChoiceSelected == 2) {
        var curr = new Date();
        this.from_date = this.selectedformatDates(curr);
        this.to_date = this.selectedformatDates(curr);
        // this.process();
      } else if (this.ChoiceSelected == 3) {
        var curr = new Date();
        var first = curr.getDate() - curr.getDay();
        var last = first - 6;
        var firstday = new Date(curr.setDate(first)).toUTCString();
        var lastday = new Date(curr.setDate(last)).toUTCString();
        //console.log(curr.setDate(first));
        //console.log(curr.setDate(last));
        if (curr.setDate(first) > curr.setDate(last)) {
          this.from_date = this.selectedformatDates(lastday);
          this.to_date = this.selectedformatDates(firstday);
        } else if (curr.setDate(first) < curr.setDate(last)) {
          this.from_date = this.selectedformatDates(firstday);
          this.to_date = this.selectedformatDates(lastday);
        }
        // this.process();
      } else if (this.ChoiceSelected == 4) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);
        this.from_date = this.selectedformatDates(firstDay);
        this.to_date = this.selectedformatDates(lastDay);
        // this.process();
      } else {
        this.from_date = "";
        this.to_date = "";
      }
    },
    selectedformatDate(date, format) {
      let v = this;
      var Days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var d = new Date(date),
        month = "" + d.getMonth(),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        days = d.getDay();

      //   if (month.length < 2) month = "0" + month;
      //   if (day.length < 2) day = "0" + day;

      //return [year, month, day].join("-");
      return [Days[days], day, months[month], year].join(" ");
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    process() {
      if (
        this.from_date == "" ||
        this.to_date == "" ||
        this.SelectBranch == "All"
      ) {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขาและวันที่";
      } else {
        this.head_date = [];
        this.table_head_model.date = [];
        var start = new Date(this.from_date);
        var end = new Date(this.to_date);
        //console.log(start)
        // console.log(end)

        for (var d = start; d <= end; d.setDate(d.getDate() + 1)) {
          console.log(this.selectedformatDates(d));
          this.table_head_model.date.push(this.selectedformatDate(d));
          this.head_date.push(this.selectedformatDates(d));
          //console.log(this.table_head_model.date);
        }

        this.commitSetShowLoading(true);
        let searchVal = "";
        if (this.SearchData == undefined) {
          searchVal = "";
        } else {
          searchVal = this.SearchData;
        }
        if (this.departmentSelect == "All") {
          this.department_Select = "";
        } else {
          this.department_Select = this.departmentSelect;
        }

        if (this.branchSelect == "All") {
          this.branch_Select = "";
        } else {
          this.branch_Select = this.branchSelect;
        }

        DocumentService.getTimeChecklist(
          this.branch_Select,
          this.department_Select,
          this.emp_code,
          this.from_date,
          this.to_date
        ).then((res) => {
          console.log(res);
          this.datacheckin = res.data;
          this.commitSetShowLoading(false);
          this.setShowDetail(this.datacheckin);
          //  console.log("222222");
          this.table_datalist = this.datacheckin;
          console.log(this.table_datalist);
        });
      }
    },
    viewcalendar(code) {
      var date = "";
      this.calendarDialog = true;
      this.table_datalist.forEach((user_finger) => {
        if (code == user_finger.code) {
          user_finger.processTimes.forEach((element) => {
            this.time.push(element);
          });
          //  console.log(this.head_date)
          //  console.log(this.time)
        }
      });
    },
    setShowDetail(response) {
      let ng = this;
      this.bodyHtml = "";
      this.footerHtml = "";
      this.responvalue = response;
      // for (var i = 0; i < response.length; i++) {
      //  console.log(response)

      // }
      this.renderheader();

      response
        .sort(function (a, b) {
          a.code.localeCompare(b.code);
        })
        .sort(function (a, b) {
          a.department_name.localeCompare(b.department_name);
        });
      let retData = ng.groupBy(response, "department_name");

      for (let item in retData) {
        let departmentHtml = "";
        let rowHtml = "";
        let footerDepartmentHtml = "";
        let departName =
          item.toString() == "" ? "No Department" : item.toString();

        departmentHtml += this.renderDepartment(departName, response);
        retData[item].forEach(function (employee, i) {
          if (employee.isResign == false) {
            // console.log("checkdata retdata: ", employee);
            rowHtml += ng.renderNormalRow(employee);
            //  console.log("rowHtml")
            // console.log(rowHtml)
          }
        });
        ng.bodyHtml += departmentHtml + rowHtml;
      }
      this.showbodyhtml = this.bodyHtml;
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    renderNormalRow(item) {
      let empTypeText = "";
      let ng = this;
      if (item.isResign == false) {
        let htmlz =
          `<tr>` +
          `<td nowrap >` +
          item.code +
          `</td>` +
          `<td nowrap >` +
          item.name +
          `</td>`;

        if (this.table_head_model.date.length > 0) {
          this.head_date.forEach((time) => {
            let processTimeCheckin = "";
            let processTimePlan = "";
            let Holiday = "";
            let Total = "";
            item.processTimes.forEach((checkdate) => {
              if (
                time == checkdate.date &&
                checkdate.isCommission.toString() == "true"
              ) {
                Total += `<div style="color:green">ได้เบี้ยขยัน</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_absenttime != "0.0" &&
                checkdate.total_absenttime != "0"
              ) {
                Total +=
                  `<div style="color:#B71C1C">จำนวนที่ขาด(เวลา) ` +
                  checkdate.total_absenttime +
                  ` ชั่วโมง</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_absentday != "0.0" &&
                checkdate.total_absentday != "0"
              ) {
                Total +=
                  `<div style="color:#E53935">จำนวนที่ขาด(วัน) ` +
                  checkdate.total_absentday +
                  ` วัน</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_absenttime_event != "0.0" &&
                checkdate.total_absenttime_event != "0"
              ) {
                Total +=
                  `<div style="color:red">ขาดในวันหยุดพิเศษ ` +
                  checkdate.total_absentday +
                  ` วัน</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_ottime != "0.0" &&
                checkdate.total_ottime != "0"
              ) {
                Total +=
                  `<div style="color:green">ทำงานล่วงเวลา ` +
                  checkdate.total_ottime +
                  ` ชั่วโมง</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_ottime_event != "0.0" &&
                checkdate.total_ottime_event != "0"
              ) {
                Total +=
                  `<div style="color:#009688">ทำงานล่วงเวลาวันพิเศษ ` +
                  checkdate.total_ottime_event +
                  ` ชั่วโมง</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_out_before_time != "0.0" &&
                checkdate.total_out_before_time != "0"
              ) {
                Total +=
                  `<div style="color:#9C27B0">ออกก่อนเวลา ` +
                  checkdate.total_out_before_time +
                  ` นาที</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_leavetime != "0.0" &&
                checkdate.total_leavetime != "0"
              ) {
                Total +=
                  `<div style="color:#FB8C00">ลาหักเงิน ` +
                  checkdate.total_leavetime +
                  ` ชั่วโมง</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_leaveday != "0.0" &&
                checkdate.total_leaveday != "0"
              ) {
                Total +=
                  `<div style="color:#E65100">วันที่ลา ` +
                  checkdate.total_total_leaveday +
                  ` วัน</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_leavetime_event != "0.0" &&
                checkdate.total_leavetime_event != "0"
              ) {
                Total +=
                  `<div style="color:#FF6D00">วันพิเศษที่ลา ` +
                  checkdate.total_leavetime_event +
                  ` วัน</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_leavetime_uncut != "0.0" &&
                checkdate.total_leavetime_uncut != "0"
              ) {
                Total +=
                  `<div style="color:#F4511E">ลาไม่หักเงิน ` +
                  checkdate.total_leavetime_uncut +
                  ` ชั่วโมง</div>`;
              }
              if (
                time == checkdate.date &&
                checkdate.total_latetime != "0.0" &&
                checkdate.total_latetime != "0"
              ) {
                Total +=
                  `<div style="color:#DD2C00">มาสาย ` +
                  checkdate.total_latetime +
                  ` นาที</div>`;
              }

              if (
                time == checkdate.date &&
                checkdate.isProfileHoliday == true
              ) {
                //console.log("time", time);
                //console.log(checkdate.date);
                Holiday = checkdate.from;
                //console.log(Holiday);

                htmlz +=
                  `<td nowrap colspan='3' style="text-align:center;background-color:#C5E1A5;"><br><br><strong>` +
                  Holiday +
                  `</strong></td>`;
              } else if (
                time == checkdate.date &&
                checkdate.isHoliday == true &&
                checkdate.isProfileHoliday == false
              ) {
                // console.log("time", time);
                // console.log(checkdate.date);
                htmlz += `<td nowrap colspan='3' style="text-align:center;background-color:#C5E1A5;"><br><br>วันหยุด</td>`;
              } else if (
                time == checkdate.date &&
                checkdate.processTimeResults != null &&
                checkdate.isProfileHoliday == false
              ) {
                // console.log("time", time);
                //console.log(checkdate.date);
                var check = null;
                checkdate.processTimeResults.forEach((checkin) => {
                  //  console.log("checkin.time_checkin", checkin.time_checkin);
                  if (checkin.time_plan != null) {
                    if (checkin.time_plan != check) {
                      processTimePlan +=
                        `<div>` + ng.timeformat(checkin.time_plan) + `</div>`;
                    }

                    //  console.log("checkin.time_plan", checkin.time_plan);
                  }
                  if (checkin.time_checkin != null) {
                    console.log(
                      "sssss",
                      ng.checktimeformat(checkin.time_checkin).split("*")
                    );
                    if (
                      ng.checktimeformat(checkin.time_checkin).split("*")
                        .length > 1 &&
                      checkin.time_plan != check
                    ) {
                      processTimeCheckin +=
                        `<div style="color:red">` +
                        ng.checktimeformat(checkin.time_checkin).split("*")[0] +
                        `*</div>`;
                    } else {
                      processTimeCheckin +=
                        `<div >` +
                        ng.checktimeformat(checkin.time_checkin).split(":")[0] +
                        ":" +
                        ng.checktimeformat(checkin.time_checkin).split(":")[1] +
                        `</div>`;
                    }
                  } else if (checkin.time_checkin == null) {
                    processTimeCheckin += `<div>-</div>`;
                  }
                  check = checkin.time_plan;
                  Holiday = " ";
                });
                htmlz +=
                  `<td nowrap style="text-align:center;">` +
                  processTimePlan +
                  `</td><td nowrap style="text-align:center;">` +
                  processTimeCheckin +
                  `</td></td><td nowrap style="text-align:center;">` +
                  Total +
                  `</td>`;
              }
            });
          });
        }
        htmlz += `</tr>`;

        return htmlz;
      }
    },
    renderDepartment(departmentName, item) {
      let ng = this;
      let html = "";
      html += `<tr style="background-color:#fcf8e3">`;
      html += `<td nowrap colspan='2'>` + departmentName + `</td>`;
      for (var i = 0; i < this.head_date.length * 3; i++) {
        html += `<td style="border-left:0px;border-right:0px;"></td>`;
      }

      html += `</tr>`;
      return html;
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    renderheader() {
      this.table_head_count = 1;
      let tableheader = "";
      let tableheader2 = "";
      let ng = this;
      tableheader += `<th nowrap rowspan ="2" >รหัส</th>`;
      tableheader += `<th nowrap rowspan ="2" >ชื่อ</th>`;

      if (this.table_head_model.date.length > 0) {
        this.table_head_model.date.forEach((date) => {
          this.table_head_count += 1;
          tableheader += `<th nowrap colspan='3'>` + date + `</th>`;
          tableheader2 += `<th nowrap>Time Plan</th><th nowrap>Time Checkin</th><th nowrap>Summary</th>`;
        });
      }
      this.showheadhtml = tableheader;
      this.showheadhtml2 = tableheader2;
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    timeformat(date) {
      return moment(date).format("HH:mm");
    },
    checktimeformat(date) {
      let d = [];
      let c = [];
      d = date.split(" ");
      c = d[1].split(":00.0");
      //console.log(c[0]);
      return c[0];
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    doCopyTable() {
      let el = document.getElementById("table_detail");
      let body = document.body;
      let range;
      let sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      }
      document.execCommand("Copy");
      alert("Copy Table to Clipboard");
    },
    printTable() {
      window.print();
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.name;
      this.delDialog.emp_code = data.firstName + " " + data.lastName;
      this.delDialog.date = data.add_date;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteExpenses(this.delDialog.roworder)
        .then((res) => {
          this.delDialogStatus = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    checkbutton(buttonlist) {
      if (buttonlist == 1) {
        this.buttonlist = 1;
        console.log("table");
      } else {
        this.buttonlist = 0;
        console.log("list");
      }
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}
thead tr:nth-child(1) th {
  position: sticky;
  top: 0;
}
thead tr:nth-child(2) th {
  position: sticky;
  top: 43px;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1020px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
@media only screen and (min-device-width: 772px) and (max-device-width: 1020px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>


